import React, { useState } from 'react';
import { FieldControl, Label, Select, SelectOption } from '@americanexpress/dls-react';

import ManualAccountService from '../../../../services/manualAccount.service';
import { AddAccountViewTemplateModel } from 'src/types/view-models/addAccount/addAccount.view.model';
import Drawer from 'src/components/drawer/Drawer';
import { ManualAccountType, ManualAccount } from 'src/types/manualAccount.model';

const selectElementId = 'manual-account-type-select';

export default function AddAccountViewTemplate({
    title,
    accountTypes,
    initialType,
    editManualAccount,
    callout,
    onSubmitCallback,
    handleBack
}: AddAccountViewTemplateModel): JSX.Element {
    const [selectedAccountType, setSelectedAccountType] = useState<ManualAccountType>(
        ManualAccountService.getManualAccountType(editManualAccount) || initialType
    );

    /** Intermediate function to wrap handleReloadUser, refreshAccounts, handleBack because they are defined by props */
    const onSubmit = async (
        formValues: any,
        manualAccount: ManualAccount,
        isDebt: boolean,
        type?: string,
        subtype?: string
    ): Promise<void> => {
        await ManualAccountService.upsertManualAccount(formValues, manualAccount, isDebt, type, subtype);
        void onSubmitCallback();
    };

    return (
        <Drawer
            drawerProps={{ history }} // TODO do we need this?
            withBackButton
            handleBack={handleBack}
            title={title}
        >
            <FieldControl className="account-selector-container">
                <Label htmlFor={selectElementId} id={selectElementId}>
                    Type
                </Label>
                <Select
                    id={selectElementId}
                    value={selectedAccountType}
                    onChange={(e: any) => setSelectedAccountType(e.target.value)}
                    disabled={!!editManualAccount}
                    required
                    fluid
                >
                    <SelectOption />
                    {accountTypes.map((key) => (
                        <SelectOption key={`add-accounts-row-${key}`} value={key}>
                            {ManualAccountService.addAccountForms[key]?.label}
                        </SelectOption>
                    ))}
                </Select>
            </FieldControl>

            {ManualAccountService.addAccountForms[selectedAccountType]?.renderForm(
                editManualAccount,
                onSubmit,
                handleBack
            )}

            {callout}
        </Drawer>
    );
}
